export function isInvestmentProjectionSimulation(
  simulationType: string
): boolean {
  return simulationType === "APE" || simulationType === "MLXAPE";
}
